import { render } from "./PageNotFound.vue?vue&type=template&id=7d6c49ba&scoped=true"
const script = {}

import "./PageNotFound.vue?vue&type=style&index=0&id=7d6c49ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d6c49ba"]])

export default __exports__